import Button from 'components/form/Button'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import Tooltip from 'components/tooltip/Tooltip'
import CopyAdGroupsDialog from 'features/dashboard/operation/adGroupCopy/CopyAdGroupsDialog'
import { useDialog } from 'features/dialog/Dialog'

const AdGroupCopyButton = () => {
  const { selectedIds, content } = useDashboardTableSelector()
  const [CopyAdGroups, showCopyAdGroups, hideCopyAdGroups] = useDialog()
  const hasSameBizChannel =
    selectedIds.length === 1 ||
    (selectedIds.length > 1 &&
      content
        .filter(({ id }) => selectedIds.includes(id))
        .map(
          ({
            parentDomainInfo: {
              bizChannel: { id },
            },
          }) => id
        )
        .every((value, index, array) => value === array[0]))
  return (
    <>
      {hasSameBizChannel ? (
        <Button line onClick={showCopyAdGroups}>
          복사
        </Button>
      ) : (
        <Tooltip
          tag="button"
          container="dashboardWrap"
          content="선택한 광고그룹의 비즈채널이 서로 동일할 때만 복사 버튼 활성화"
          position="bottom alignLeft"
          offsetY={5}
          wrapperClassName="btn_gm in_active"
          style={{ pointerEvents: 'auto' }}>
          <span className="inner_g">복사</span>
        </Tooltip>
      )}
      <CopyAdGroups type="basic_layer" className="copy_layer">
        <CopyAdGroupsDialog handleClose={hideCopyAdGroups} />
      </CopyAdGroups>
    </>
  )
}
export default AdGroupCopyButton
